import { render } from "./ClockFace.vue?vue&type=template&id=f42b2070&scoped=true"
import script from "./ClockFace.vue?vue&type=script&lang=js"
export * from "./ClockFace.vue?vue&type=script&lang=js"

import "./ClockFace.vue?vue&type=style&index=0&id=f42b2070&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f42b2070"

export default script